<tour-step-template>
    <ng-template let-step="step">
        <mat-card (click)="$event.stopPropagation()">
            <mat-card-title>
                {{step?.title | translate}}
            </mat-card-title>
            <mat-card-content>
                {{step?.content | translate}}
            </mat-card-content>
            <mat-card-actions>
                <button mat-icon-button [disabled]="!tourService.hasPrev(step)" (click)="tourService.prev()">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <button mat-icon-button [disabled]="!tourService.hasNext(step)" (click)="tourService.next()">
                    <mat-icon>chevron_right</mat-icon>
                </button>
                <button mat-button (click)="tourService.end()">{{step?.endBtnTitle}}</button>
            </mat-card-actions>
        </mat-card>
    </ng-template>
</tour-step-template>
<div id="wrapper" class="app-{{appId}}-theme" >
    <div class="mat-app-background">
        <div id="header">
            <app-header></app-header>
            <mat-progress-bar  class="progressBar" color="primary"
                   mode="indeterminate"  *ngIf="loading">
            </mat-progress-bar>
        </div>
            <div id="content">
                <div>
                    <div class="contentDiv" id="scroller">
                        <!--<router-outlet (activate)="onActivate($event)" ></router-outlet>-->
                        <router-outlet (activate)="onOutletLoaded($event)" ></router-outlet>
                    </div>
                </div>
            </div>
            <div id="cookieLaw">
                <cookie-law >
                    <span class="CookieText" translate>keyword_$72</span> &nbsp;
                    <span class="underline" routerLink="policies" translate>keyword_$73</span>
                </cookie-law>
            </div>
            <app-playlist-content *ngIf="isPlaylistOpen"></app-playlist-content>
            <!-- <div class="chatbox">
                <app-messenger></app-messenger>
            </div> -->
        <div id="footer"  class="footer" [ngStyle]="setMyStyles2()">
            <app-footer></app-footer>
        </div>
    </div>
</div>
